'use strict';

import React from 'react';
import html2canvas from 'html2canvas';
import QRCode from 'qrcode.react';
import 'styles/PostCard.scss';

class PostCardComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postUrl: '',
      loading: false
    };
    this.generatePost = this.generatePost.bind(this)
    this.saveFile = this.saveFile.bind(this)
  }
  generatePost() {
    if (!this.state.loading) {
      this.setState({ loading: true })
      let that = this
      html2canvas(document.getElementById('post-card'),{
        allowTaint: false,
        scale: 3,
        useCORS: true,
        logging: false
      }).then(function(canvas) {
        let url = canvas.toDataURL()
        that.setState({postUrl: url, loading: false})
        that.saveFile(url,'post.png')
      });
    }
  }
  saveFile(data, filename) {
    const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
    save_link.href = data;
    save_link.download = filename;

    const event = document.createEvent('MouseEvents');
    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    save_link.dispatchEvent(event);
  }
  render() {
    const {title, desc, cover, url, userInfo, togglePostCard} = this.props
    let userReveal;
    if (userInfo) {
      userReveal = (
        <div className="addition">
          <div className="cover">
            <img src={encodeURI(userInfo.avatar)}></img>
          </div>
          <div className="name">{userInfo.name}</div>
          <div className="alert">”我正在参加小地球旅行的福利活动，请为我投上宝贵的一票“</div>
        </div>
      )
    }
    if (this.state.postUrl) {
      return (<div className="postcard segment post">
        <button onClick={togglePostCard} className="close-button" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="post-cover">
          <img src={this.state.postUrl}/>
        </div>
        <div className="alert">长按图片可保存到相册</div>
      </div>)
    } else {
      return (
        <div className="postcard segment post">
          <button onClick={togglePostCard} className="close-button" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="post-card" id="post-card">
            <div className="post-img">
              <img src={encodeURI(cover)}/>
            </div>
            <div className="post-content">
              <div className="post-title">{title}</div>
              {userReveal}
              <div className="post-desc">{desc?desc:'小地球旅行, 只到达本星球最有趣的地方'}</div>
              <div className="post-line"></div>
              <div className="post-bottom">
                <div className="float left post-qr">
                  <QRCode value={url?url:location.href} fgColor="gray" size={60} />
                </div>
                <div className="float right post-alert">
                  长按二维码，查阅美文
                </div>
                <div className="clear"></div>
              </div>
            </div>
          </div>
          <button className="expanded button create-post" onClick={this.generatePost}>{this.state.loading?'生成中...':'生成海报'}</button>
        </div>
      )
    }
  }
}

PostCardComponent.displayName = 'PostCardComponent';
export default PostCardComponent;



// WEBPACK FOOTER //
// ./src/components/PostCardComponent.js